import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import Header from "components/Headers/Header";

const CreaVehiculo = () => {
  const { id } = useParams();
  const [placa, setPlaca] = useState("");
  const [modelo, setModelo] = useState("");
  const [tipoVehiculo, setTipoVehiculo] = useState("");
  const [vin, setVin] = useState("");
  const [marca, setMarca] = useState(null);
  const [marcas, setMarcas] = useState([]);

  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const response = await axios.get(
          "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerMarcas",
        );
        const options = response.data.map((marca) => ({
          value: marca.id,
          label: marca.marca,
        }));
        setMarcas(options);
      } catch (error) {
        console.error("Error al obtener marcas:", error);
      }
    };

    fetchMarcas();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if ((placa && vin) || (!placa && !vin)) {
      Swal.fire({
        icon: "warning",
        title: "Validación",
        text: "Debe ingresar solo la placa o el VIN, no ambos.",
      });
      return;
    }

    try {
      const { data } = await axios.post(
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/CrearVehiculo",
        {
          placa: placa.toUpperCase(),
          modelo,
          vin: vin.toUpperCase(),
          tipoVehiculo,
          propietarioId: id,
          idMarca: marca?.value,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "¡Vehículo creado!",
        text: "El vehículo fue registrado exitosamente.",
        confirmButtonColor: "#3085d6",
      }).then(() => {
        window.location.href = `/admin/CreaOrden/${data}`;
      });
    } catch (error) {
      console.error("Error al crear vehículo:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo crear el vehículo. Detalle: " + error.message,
      });
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0"> Información del Vehículo</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="input-placa">Placa</label>
                          <Input
                            id="input-placa"
                            type="text"
                            value={placa}
                            onChange={(e) =>
                              setPlaca(e.target.value.toUpperCase())
                            }
                            disabled={vin.length > 0}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="input-vin">VIN</label>
                          <Input
                            id="input-vin"
                            type="text"
                            value={vin}
                            onChange={(e) =>
                              setVin(e.target.value.toUpperCase())
                            }
                            disabled={placa.length > 0}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="input-modelo">Modelo</label>
                          <Input
                            id="input-modelo"
                            type="text"
                            value={modelo}
                            onChange={(e) => setModelo(e.target.value)}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="select-tipo-vehiculo">
                            Tipo Vehículo
                          </label>
                          <Input
                            type="select"
                            id="select-tipo-vehiculo"
                            value={tipoVehiculo}
                            onChange={(e) => setTipoVehiculo(e.target.value)}
                            required
                          >
                            <option value="">Seleccionar Tipo</option>
                            {[
                              "Automóvil",
                              "Van",
                              "Microbús",
                              "Bus",
                              "Camioneta",
                              "Camión",
                              "Campero",
                              "Tractocamión",
                              "Motocarro",
                              "Montacargas",
                            ].map((tipo) => (
                              <option key={tipo} value={tipo}>
                                {tipo}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label htmlFor="input-marca">Marca</label>
                          <Select
                            id="input-marca"
                            options={marcas}
                            onChange={setMarca}
                            placeholder="Seleccione una marca"
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                  <Button type="submit" color="primary" size="lg">
                    SIGUIENTE
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreaVehiculo;
